<template>
<div style="background:#fff">
  <div class="pz-box">
    <div v-show="isShowImportant == true">
      <h2 class="upload-titile input-title-hq red-required">{{pzTitle}}</h2>
    </div>
    <div v-show="isShowImportant == false">
      <h2 class="upload-titile input-title-hq ">{{pzTitle}}</h2>
    </div>

    <van-checkbox-group v-model="getChoosePZlist">
      <van-cell v-for="(item, index) in pzList" clickable :key="index" :title-class="titleClass" :title="`${item.pinming} —— ${item.leibie}`" @click="toggle(index)">
        <template #right-icon>
          <van-checkbox :name="`${item.pinming}`" ref="checkboxes" />
        </template>
      </van-cell>
    </van-checkbox-group>
  </div>


</div>
</template>

<script>
import api from "@/fetch/api"
import {
  Dialog,
  Toast,
} from 'vant';
export default {
  data() {
    return {
      pzList: [],
      selectedData: [],
      titleClass:"title-class-hq",
    }
  },
  props: {
    pzTitle: {
      type: String,
      default: ""
    },
    isShowImportant: {
      type: Boolean,
      default: true,
    },
    resultPz: {
      type: Array,
      default: function() {
        return []
      }
    },
  },
  created() {
    var that = this;
    that.getPzList();
    // var id = this.$route.params.id;
    // if (id) {
    //   that.getResultPz(id);
    // }
  },
  computed: {
    getChoosePZlist: function() {
      return this.resultPz
    }
  },
  methods: {
    getPzList() {
      var that = this;
      api.getPzList().then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var pzList = resData.data;
          that.$data.pzList = pzList;
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            that.$router.push({
              name: 'index'
            })
          });
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('连接失败，请刷新页面');

      });
    },
    toggle(index) {
      //this.$refs.checkboxes[index].toggle();
      let selectedData = [];
      var length = this.$refs.checkboxes.length;
      var pinming = "";

      for (var i = 0; i < length; i++) {
        if (this.$refs.checkboxes[i].checked == true) {
          if (this.$refs.checkboxes[i].name != this.$refs.checkboxes[index].name) {
            pinming = this.$refs.checkboxes[i].name;
            selectedData.push(pinming);
          }
        } else {
          if (this.$refs.checkboxes[i].name == this.$refs.checkboxes[index].name) {
            pinming = this.$refs.checkboxes[i].name;
            selectedData.push(pinming);
          }
        }
      }


      this.$emit('getChosePz', selectedData);
    },

    // getResultPz(id) {
    //   var that = this;
    //   var weburl = that.GLOBAL.weburl;
    //   api.getChetouBeianDetail(id).then(function(resData) {
    //     var res = JSON.parse(resData);
    //     if (res.respCode == "0") {
    //       var detail = res.data;
    //       var daoluyszjyfw = that.daoluyszjyfw = detail.daoluyszjyfw;
    //       daoluyszjyfw = daoluyszjyfw.replace('1,4-丁二醇', '丁二醇');
    //       var pzArrayOld = daoluyszjyfw.split(',');
    //
    //       let pzArrayNew = [];
    //       for (var i = 0; i < pzArrayOld.length; i++) {
    //         if (pzArrayOld[i] == '丁二醇') pzArrayOld[i] = '1,4-丁二醇';
    //         pzArrayNew.push(pzArrayOld[i]);
    //       }
    //
    //       // let pzArrayNew = [];
    //       // let pzObject = {};
    //       // for (var i = 0; i < pzArrayOld.length; i++) {
    //       //   if(pzArrayOld[i] == '丁二醇')  pzArrayOld[i] = '1,4-丁二醇';
    //       //   pzObject = {
    //       //     'leibie': "",
    //       //     'pinming': pzArrayOld[i]
    //       //   };
    //       //   pzArrayNew.push(pzObject);
    //       // }
    //
    //       that.resultPz = pzArrayNew;
    //     }
    //   }).catch(function(err) {
    //     Toast.fail('连接失败，请刷新页面');
    //   });
    // }
  }
}
</script>
<style lang="scss" scoped>
.pz-box {
    .van-checkbox-group {
        margin-left: 1rem;
    }
}

.upload-titile {
    padding: 0.675rem 1rem;
}
</style>
